import { render } from "./SendersAddComponent.vue?vue&type=template&id=76736ee5&scoped=true"
import script from "./SendersAddComponent.vue?vue&type=script&lang=js"
export * from "./SendersAddComponent.vue?vue&type=script&lang=js"

import "./SendersAddComponent.vue?vue&type=style&index=0&id=76736ee5&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76736ee5"]])

export default __exports__